import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';



@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ]
})
export class EtiquetaModule { 
  id:string;
  etiquetaNombre:string;
  producto:string;
  name_proveedor:string;
  name_producto:string;
  m_product_id:string;
  provedor_identificacion:string;

}
